export default "// tsconfig.json\n\n{\n  \"compilerOptions\": {\n    \"types\": [\"vuetify\"]\n  }\n}\n";